"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var md5_1 = require("./utils/md5");

var parser = require("./parser");

var invalidInputMessage = 'invalid input';

function read(input, options) {
  var data;

  if (typeof Buffer !== 'undefined' && input instanceof Buffer) {
    data = input;
  } else if (typeof ArrayBuffer !== 'undefined' && input instanceof ArrayBuffer) {
    data = new Uint8Array(input);
  } else {
    return Promise.reject(new Error(invalidInputMessage));
  }

  return parser.read(data, Object.assign({
    getTransactionId: function getTransactionId(transaction) {
      return md5_1.default(JSON.stringify(transaction));
    }
  }, options)).catch(function () {
    return Promise.reject(new Error(invalidInputMessage));
  });
}

exports.read = read;